'use client';
import { HStack, Text, Image } from '@chakra-ui/react';
import * as React from 'react';
import { useRouter } from '@/i18n/routing';
import { useColorMode } from '@/components/ui/color-mode';
import { useTheme } from 'next-themes';
import { WildmetaIcon } from './wildmeta';

interface LogoProps {
  fontSize?: number;
  width?: number;
  height?: number;
  disableJump?: boolean;
  logoJumpUrl?: string;
}

export function Logo({ fontSize = 19, width = 38, height = 42, disableJump = false, logoJumpUrl = '/' }: LogoProps) {
  const router = useRouter();
  // const { resolvedTheme } = useTheme();

  return (
    <HStack gap={1} onClick={() => !disableJump && router.push(logoJumpUrl)}>
      <Image
        src="/images/logo-icon.png"
        alt="Wildmeta"
        objectFit={'contain'}
        w={`${width}px`}
      />

      <WildmetaIcon fontSize={fontSize}  />
    </HStack>
  );
}
